export const formatSearchString = <T extends Nullable<string>>(str: T): T => {
  if (!str) {
    return str;
  }
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents https://ricardometring.com/articles/javascript-replace-special-characters
    .trim()
    .toLowerCase() as T;
};
